import React, { useState } from "react";
import { Helmet } from "react-helmet";
import emailjs from "emailjs-com";
import "./Contact.css";

const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_ra96bsr";
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_8wfjazv";
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "ZxNCbfGTdfZ9e4zZs";
const RESUME_URL = "/CV_KAsad.pdf";
const CONTACT_EMAIL = "khaledasad94@outlook.com";
const LINKEDIN_URL = "https://www.linkedin.com/in/khaled-asad/";

export default function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [isSending, setIsSending] = useState(false);

  const handleChange = (event) => {
    setFormData((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSending) return;

    setIsSending(true);
    setSubmitted(false);
    setError("");

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          name: formData.name.trim(),
          email: formData.email.trim(),
          message: formData.message.trim(),
        },
        EMAILJS_PUBLIC_KEY
      );
      setSubmitted(true);
      setFormData({ name: "", email: "", message: "" });
    } catch {
      setError("The form could not send right now. Please email me directly instead.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact | Khaled Asad</title>
        <meta name="description" content="Contact Khaled Asad about data engineering roles and projects." />
      </Helmet>

      <div className="page-shell contactPage">
        <div className="cp-panel contactPanel">
          <div className="cp-panel__inner">
            <header className="contactHeader">
              <div>
                <p className="contactKicker">OPEN CHANNEL</p>
                <h1 className="cp-title">Contact</h1>
                <p className="cp-subtitle">
                  Tell me what you are building, hiring for, or trying to make more reliable.
                </p>
              </div>
              <a className="contactResumeBtn" href={RESUME_URL} target="_blank" rel="noopener noreferrer">
                Download resume
              </a>
            </header>

            <div className="contactGrid">
              <section className="cp-card contactFormCard" aria-label="Contact form">
                <p className="contactFormHint">All fields are required.</p>

                {submitted && (
                  <div className="contactAlert contactAlert--success" role="status">
                    Message sent. I will get back to you soon.
                  </div>
                )}
                {error && (
                  <div className="contactAlert contactAlert--error" role="alert">
                    {error}
                  </div>
                )}

                <form className="contactForm" onSubmit={handleSubmit}>
                  <label className="contactField" htmlFor="contact-name">
                    <span>Name</span>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your name"
                      autoComplete="name"
                      maxLength={100}
                      required
                    />
                  </label>

                  <label className="contactField" htmlFor="contact-email">
                    <span>Email</span>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="you@company.com"
                      autoComplete="email"
                      maxLength={180}
                      required
                    />
                  </label>

                  <label className="contactField" htmlFor="contact-message">
                    <span>Message</span>
                    <textarea
                      id="contact-message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="A role, a project, or just hello..."
                      maxLength={4000}
                      rows={7}
                      required
                    />
                  </label>

                  <div className="contactActions">
                    <button type="submit" disabled={isSending} aria-busy={isSending}>
                      {isSending ? "Sending..." : "Send message"}
                    </button>
                    <a href={`mailto:${CONTACT_EMAIL}`}>Email directly</a>
                  </div>
                </form>
              </section>

              <aside className="contactSide" aria-label="Direct contact details">
                <section className="cp-card contactSideCard">
                  <p className="contactSideLabel">DIRECT</p>
                  <a href={`mailto:${CONTACT_EMAIL}`}>
                    <strong>Email</strong>
                    <span>{CONTACT_EMAIL}</span>
                  </a>
                  <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
                    <strong>LinkedIn</strong>
                    <span>khaled-asad</span>
                  </a>
                </section>

                <section className="cp-card contactLocationCard">
                  <p className="contactSideLabel">LOCATIONS</p>
                  <strong>Atlanta, Georgia</strong>
                  <strong>Zadar, Croatia</strong>
                  <span>Working across US and European time zones.</span>
                </section>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
